import './CustomDot.css';   

function CustomDot({ color = 'red', size = '16px',label='', isFlashing = false }) {
    return(
  <div style={{
    backgroundColor: color,
    width: size,
    height: size,
    borderRadius: '50%', 
    border: '2px solid white', 
    boxShadow: '0 0 5px rgba(0, 0, 0, 0.5)', 
  }}
  className={isFlashing ? 'flashing-dot' : ''}  >
    <div className='customlbl'>
         {label}
        </div>

  </div>);
}

export default CustomDot;
